import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { AppState } from "src/app/reducers";
import { BuscadorPersonasService } from "../../services/buscador-personas.service";
import { ToastService } from "src/app/services/toast.service";
import { buscadorPersonaFotoCancelled, buscadorPersonaFotoDoNothing, buscadorPersonaFotoLoaded, buscadorPersonaFotoRequested, buscadorPersonaPageCancelled, buscadorPersonaPageLoaded, buscadorPersonaPageRequested } from "./buscador-personas.actions";
import { catchError, map, mergeMap, Observable, of, switchMap, withLatestFrom } from "rxjs";
import { buscadorPersonaEntityFunc, buscadorPersonasNextPageNum, buscadorPersonasPageSize } from "./buscador-personas.selectors";
import { BuscadorResponse, PersonaBuscador } from "src/common/buscador-personas";

@Injectable()
export class BuscadorPersonasEffects {

	constructor( private actions$: Actions, private store: Store<AppState>, private service: BuscadorPersonasService, private toastService: ToastService ){
	}

	loadPersonas$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( buscadorPersonaPageRequested ),
			withLatestFrom( this.store.select( buscadorPersonasNextPageNum ), this.store.select( buscadorPersonasPageSize ) ),
			switchMap( ([ data, nextPageNum, pageSize ]) => {
				let cleared: boolean = false;
				let searchText: string = data.text;

				return this.service.findPersonasByPage( { pageNum: nextPageNum, pageSize }, searchText )
					.pipe(
						map( buscadorData => {
							let action: Action;
							if( !buscadorData ) {
								action = buscadorPersonaPageCancelled();
							} else {
								++nextPageNum;
								action = buscadorPersonaPageLoaded({ cleared, nextPageNum, buscadorData });
							}
							return action;
						}),
						catchError( error => {
							if( error.status === 404 ) {
								let buscadorData: BuscadorResponse = { total: 0, personas: [] };
								return of( buscadorPersonaPageLoaded({ cleared, nextPageNum: 0, buscadorData }) )
							} else {
								this.toastService.danger( "No se pudieron obtener los resultados" );
								return of( buscadorPersonaPageCancelled() );
							}
						})
					);
			})
		);
	});

	personasLoaded$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( buscadorPersonaPageLoaded ),
			switchMap( action => {
				let personas: PersonaBuscador[] = action.buscadorData.personas;
				let result: Action[] = [];
				// Para cada idPersona de personas genero un action para recuperar la foto
				if( personas && personas.length > 0 ) {
					personas.forEach( persona => result.push( buscadorPersonaFotoRequested({ idUsuarioMf: persona.idPersona }) ) );
				} else {
					result = [ buscadorPersonaFotoDoNothing() ];
				}
				return result;
			})
		);
	});

	personaFotoRequested$ = createEffect( () => {
		return this.actions$.pipe(
			ofType( buscadorPersonaFotoRequested ),
			withLatestFrom( this.store.select( buscadorPersonaEntityFunc ) ),
			mergeMap( ([ action, buscadorPersonaEntityFunc ]) => {
				let result: Observable<Action> = null;
				let idUsuarioMf: number = action.idUsuarioMf;
				if( idUsuarioMf ) {
					let persona: PersonaBuscador = buscadorPersonaEntityFunc( idUsuarioMf );
					if( persona && persona.idPersona ) {
						result = this.service.findPersonaFoto( persona.idPersona )
							.pipe(
								map( foto => buscadorPersonaFotoLoaded({ idUsuarioMf, foto: foto.foto }) ),
								catchError( () => of( buscadorPersonaFotoCancelled({ idUsuarioMf }) ) )
							);
					}
				}

				if( !result )
					result = of( buscadorPersonaFotoCancelled({ idUsuarioMf }) );

				return result;
			})
		);
	});

}